module.exports = __webpack_public_path__ + "img/为工厂增效ico.7796dc76.png";